import React from 'react'
import {
  ServerSettingsDialogProps,
  ServerSettingsMutationProps
} from './shared'
import { BulkServerSettings } from '../servers-grid/shared'
import { Mutation } from 'react-apollo'
import { logSuccess, logError } from '../toaster'
import gql from 'graphql-tag'
import { getBulkServerSettings } from './get-bulk-server-settings'
import { ServerSettingsFormBulk } from './server-settings-form-bulk'
import { ContrastFormattedMessage } from '../contrast-formatted-message'

const mutationName = 'updateServerSettingsByIds'

export const modifyBulkServerSettingsMutation = gql`
  mutation UpdateServerSettingsInBulk(
    $organizationID: ID!
    $ids: [ID!]!
    $settings: BulkServerSettingsArg!
  ) {
    ${mutationName}(
      input: { organizationID: $organizationID, ids: $ids, settings: $settings }
    ) {
      _placeholder
    }
  }
`

interface MutationData {
  readonly __typename: 'Mutation'
  readonly [mutationName]: {
    readonly _placeholder: true
    readonly __typename: 'GenericMutationResponse'
  }
}

interface MutationVariables {
  readonly organizationID: string
  readonly ids: string[]
  readonly settings: BulkServerSettings
}

export function ModifyBulkServerSettingsDialog({
  organizationID,
  serverIDs,
  refetchQueries,
  refresh,
  closeDialog,
  isOpen,
  protect: userIsProtect,
  isFreemium
}: ServerSettingsDialogProps &
  ServerSettingsMutationProps & { readonly serverIDs: string[] }) {
  return (
    <Mutation<MutationData, MutationVariables>
      mutation={modifyBulkServerSettingsMutation}
      ignoreResults
    >
      {(mutate) => (
        <ContrastFormattedMessage id="detail_servers_successfullySavedSettings">
          {(successMessage) => (
            <ContrastFormattedMessage id="detail_servers_errorSavingSettings">
              {(errorMessage) => (
                <ServerSettingsFormBulk
                  onConfirm={async (formValue) => {
                    try {
                      await mutate({
                        refetchQueries,
                        variables: {
                          settings: getBulkServerSettings(formValue),
                          organizationID,
                          ids: serverIDs
                        },
                        optimisticResponse: {
                          [mutationName]: {
                            _placeholder: true,
                            __typename: 'GenericMutationResponse'
                          },
                          __typename: 'Mutation'
                        },
                        update: () => false // TODO TS-2908
                      })
                      logSuccess(successMessage)
                      // eslint-disable-next-line @typescript-eslint/no-floating-promises
                      refresh()
                    } catch (error) {
                      console.error(error)
                      logError(errorMessage)
                    }
                    closeDialog()
                  }}
                  onCancel={closeDialog}
                  isOpen={isOpen}
                  userIsProtect={userIsProtect}
                  isFreemium={isFreemium}
                />
              )}
            </ContrastFormattedMessage>
          )}
        </ContrastFormattedMessage>
      )}
    </Mutation>
  )
}
